import React from 'react';
import { connect } from 'react-redux';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { newCohortFromDataset } from '@/cohorts/actions';

const QueryDatasetAction = ({
  code,
  dictionaryCode,
  disabled,
  newCohort,
  newCohortCode,
}) => (
  <RibbonMenu
    name="cohort"
    icon="filter"
    message="actions.cohort.short"
    onClick={() => newCohort(newCohortCode, code, dictionaryCode)}
    className="aridhia-query-dataset-action"
    disabled={disabled}
  />
);

const mapStateToProps = ({
  cohorts: { newCohortCode },
}) => ({
  newCohortCode,
});

const mapDispatchToProps = {
  newCohort: (code, datasetCode, dictionaryCode) => (
    newCohortFromDataset(code, 'open', datasetCode, [dictionaryCode])),
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryDatasetAction);
